import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@zola/zola-ui';
import cx from 'classnames';

import './ChecklistEmptyState.less';

class ChecklistEmptyState extends Component {
  renderHeader = () => {
    const { header } = this.props;

    if (!header) return null;

    return <h1 className="checklist__emptyState--header">{header}</h1>;
  };

  renderDescription = () => {
    const { description } = this.props;

    if (!description) return null;

    return <p className="checklist__emptyState--description">{description}</p>;
  };

  renderCTA = () => {
    const { onClick, buttonCopy } = this.props;

    if (!buttonCopy) return null;

    return (
      <Button onClick={onClick} secondary className="checklist__emptyState--button">
        {buttonCopy}
      </Button>
    );
  };

  render() {
    const { className } = this.props;

    return (
      <div className={cx('checklist__emptyState--container', className)}>
        <span className="checklist__emptyState--icon" aria-hidden="true" />
        {this.renderHeader()}
        {this.renderDescription()}
        {this.renderCTA()}
      </div>
    );
  }
}

ChecklistEmptyState.propTypes = {
  header: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  buttonCopy: PropTypes.string,
};

ChecklistEmptyState.defaultProps = {
  header: 'Nothing to see here…',
  description: 'Select a different filter to view your tasks. Or clear all filters and try again.',
};

export default ChecklistEmptyState;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistEmptyState/ChecklistEmptyState.jsx